import { apiClient } from '../../plugins/api'
import {
    TOURNAMENTS_LIST_REQUEST,
    TOURNAMENTS_LIST_SUCCESS,
    TOURNAMENTS_MY_RANK_REQUEST,
    TOURNAMENTS_MY_RANK_SUCCESS, TOURNAMENTS_RANKS_REQUEST,
} from '../actions/tournament'

const state = {
    tournaments: [],
    myRanks: [],
};

const getters = {
    myRankMain: state => state.myRanks.find(rank => rank.type === 'main'),
    myRankWeekly: state => {
        return state.myRanks.find((tournament) => {
            const from = new Date(tournament.start.date);
            const to = new Date(tournament.end.date);
            to.setHours(23, 59, 59);
            const now = new Date();
            return from.getTime() < now.getTime()
                && to.getTime() > now.getTime()
                && tournament.type !== 'main';
        });
    },
};

const actions = {
    async [TOURNAMENTS_LIST_REQUEST] ({ commit }) {
        const { data } = await apiClient().get('/tournament/list');
        commit(TOURNAMENTS_LIST_SUCCESS, data);
    },
    async [TOURNAMENTS_MY_RANK_REQUEST] ({ commit }) {
        const { data } = await apiClient().get('/tournament/my-rank');
        commit(TOURNAMENTS_MY_RANK_SUCCESS, data);
    },
    async [TOURNAMENTS_RANKS_REQUEST] ({ commit }, { id }) {
        const { data } = await apiClient().get('/tournament/ranks?id=' + id);
        return data.ranks;
    },
};

const mutations = {
    [TOURNAMENTS_LIST_SUCCESS] (state, { tournaments }) {
        state.tournaments = tournaments;
    },
    [TOURNAMENTS_MY_RANK_SUCCESS] (state, { ranks }) {
        state.myRanks = ranks;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
